<script>
export default {
    methods: {
        e__422_messages(errors) {
            let er = Object.values(errors)

            return er.flat()
        }
    }
}
</script>